import images from "./images";


const team = [
    {
        id: 1,
        image: images.team1,
        name: "Cristiano Harris",
        title: "CEO",
        biography: "Cristiano Harris brings over a decade of passion and expertise to the coffee industry. As the CEO of BrewCraft Café, he has transformed the shop into a favorite destination for coffee lovers. His commitment to ethically sourced beans, innovative brews, and exceptional customer service has redefined the local coffee scene. Outside of operations, Cristiano mentors aspiring baristas and leads sustainability initiatives.",
        contacts: {
            phone: "123-456-7890",
            email: "cristiano.harris@brewcraftcafe.com",
            address: "456 Roast Street, Beanville, NY 67890",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Coffee Curation", progress: 97 },
            { id: 2, title: "Barista Training", progress: 94 },
            { id: 3, title: "Customer Engagement", progress: 92 },
            { id: 4, title: "Business Strategy", progress: 90 },
            { id: 5, title: "Sustainable Sourcing", progress: 89 },
            { id: 6, title: "Menu Innovation", progress: 93 },
        ]
    },
    {
        id: 2,
        image: images.team2,
        name: "Amy Jones",
        title: "Founder",
        biography: "Amy Jones founded BrewCraft Café with a simple vision — to bring people together over a perfect cup of coffee. With a background in culinary arts and a deep appreciation for global coffee cultures, Amy laid the foundation for a café that values authenticity, quality, and community. Her hands-on approach and eye for design have shaped every detail, from bean selection to cozy interiors.",
        contacts: {
            phone: "987-654-3210",
            email: "amy.jones@brewcraftcafe.com",
            address: "456 Roast Street, Beanville, NY 67890",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Brand Building", progress: 96 },
            { id: 2, title: "Coffee Culture", progress: 94 },
            { id: 3, title: "Interior Aesthetics", progress: 91 },
            { id: 4, title: "Leadership", progress: 93 },
            { id: 5, title: "Product Vision", progress: 92 },
            { id: 6, title: "Community Outreach", progress: 90 },
        ]
    },
    {
        id: 3,
        image: images.team3,
        name: "Paul Roger",
        title: "Manager",
        biography: "Paul Roger oversees daily operations at BrewCraft Café, ensuring everything runs smoothly — from staff coordination to customer service excellence. With years of experience in hospitality management, Paul brings a balance of professionalism and warmth, making sure every guest feels welcome and every cup meets the café’s high standards.",
        contacts: {
            phone: "555-234-6789",
            email: "paul.roger@brewcraftcafe.com",
            address: "456 Roast Street, Beanville, NY 67890",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Team Management", progress: 95 },
            { id: 2, title: "Customer Relations", progress: 93 },
            { id: 3, title: "Inventory Control", progress: 90 },
            { id: 4, title: "Operational Efficiency", progress: 92 },
            { id: 5, title: "Staff Training", progress: 89 },
            { id: 6, title: "Problem Solving", progress: 94 },
        ]
    },
    {
        id: 4,
        image: images.team4,
        name: "Scarlet David",
        title: "Manager",
        biography: "Scarlet David brings energy and precision to BrewCraft Café’s operations. With a background in hospitality and a deep passion for coffee culture, she ensures that the café delivers exceptional service and a welcoming environment. Scarlet excels in team coordination, customer satisfaction, and maintaining the high standards that define BrewCraft Café.",
        contacts: {
            phone: "555-789-3456",
            email: "scarlet.david@brewcraftcafe.com",
            address: "789 Aroma Avenue, Roasttown, IL 34567",
        },
        accounts: {
            facebook: "/#",
            linkedin: "/#",
            twitter: "/#",
            instagram: "/#"
        },
        skills: [
            { id: 1, title: "Operational Management", progress: 94 },
            { id: 2, title: "Customer Engagement", progress: 96 },
            { id: 3, title: "Staff Coordination", progress: 92 },
            { id: 4, title: "Time Management", progress: 90 },
            { id: 5, title: "Service Quality Control", progress: 93 },
            { id: 6, title: "Café Ambiance Planning", progress: 91 },
        ]
    }

];

export default team;